import { BiMenu } from "@react-icons/all-files/bi/BiMenu";
import logo from "../../assets/onze_solucoes_logo.png";
import './Topbar.css';
import { useGlobalState } from "../globalState/GlobalStateProvider";
import { GlobalSaveData } from "../globalState/GlobalSaveData";
import TopbarUserInfo from "./TopbarUserInfo";
import TopbarRelatorio from "./TopbarRelatorio";
import TopbarNotificacao from "./TopbarNotificacao";
import TopbarSaldo from "./TopbarSaldo";
import TopbarSuporte from "./TopbarSuporte";
import TopbarDegustacao from "./TopbarDegustacao";
import { useLocation } from "react-router-dom";

const Topbar = () => {
  const {state} = useGlobalState();
  const { pathname } = useLocation();
  // Na troca de senha (às vezes forçada) o usuário não pode fazer nada até alterar, então sem modais de degustação.
  const alterandoSenha = pathname.toLowerCase().startsWith("/alterarsenha");
  const handleToggleSidebar = () => {
   
    GlobalSaveData("sidebarOpen", !state.sidebarOpen);
  };

  return (
    <div id="interface-topbar">
      <div className="wrapper">
       <div  style={{paddingLeft:'10px'}}>
          <button onClick={handleToggleSidebar} style={{background:'transparent', border:'none'}}> 
            <BiMenu style={{color:'white', fontSize:'30px', cursor:'pointer'}} />
          </button>
        </div>
       
      <div style={{paddingLeft:'10px', flexGrow: 1}}><img src={state.user.nomeUsuario === 'Deoclides Quevedo' ? logo : logo} style={{width:'70px', paddingTop: '5px', paddingLeft: '5px'}} alt="Logo" /></div>
      {state.user.saldo && (<TopbarSaldo />)}
       <TopbarSuporte />
       {!alterandoSenha && <TopbarDegustacao />}
       <TopbarNotificacao />
       <TopbarRelatorio />
       <TopbarUserInfo />

        
      </div>
    </div>
  );
};

export default Topbar;
